import { ColorScale } from '@/theme/colors';

export const darkPalette = {
  primary: {
    light: ColorScale.blue[400],
    main: ColorScale.blue[500],
  },
  secondary: {
    light: ColorScale.gray[400],
    main: ColorScale.gray[500],
  },
  error: {
    light: ColorScale.red[400],
    main: ColorScale.red[500],
    dark: ColorScale.red[600],
  },
  warning: {
    light: ColorScale.yellow[400],
    main: ColorScale.yellow[500],
  },
  info: {
    light: ColorScale.blue[400],
    main: ColorScale.blue[500],
  },
  success: {
    light: ColorScale.green[400],
    main: ColorScale.green[500],
  },
  background: {
    default: ColorScale.gray[950],
    muted: ColorScale.gray[850],
    subtle: ColorScale.gray[900],
    emphasis: ColorScale.gray[700],
    accent: ColorScale.blue[900],
    info: ColorScale.blue[900],
    infoEmphasis: ColorScale.blue[400],
    success: ColorScale.green[900],
    successEmphasis: ColorScale.green[600],
    warn: ColorScale.yellow[900],
    warnEmphasis: ColorScale.yellow[500],
    danger: ColorScale.red[900],
    dangerEmphasis: ColorScale.red[500],
  },
  border: {
    default: ColorScale.gray[800],
    muted: ColorScale.gray[800],
    subtle: ColorScale.gray[900],
    emphasis: ColorScale.gray[600],
    accent: ColorScale.blue[700],
    accentEmphasis: ColorScale.blue[400],
    info: ColorScale.blue[700],
    infoEmphasis: ColorScale.blue[400],
    success: ColorScale.green[800],
    successEmphasis: ColorScale.green[400],
    warn: ColorScale.yellow[700],
    warnEmphasis: ColorScale.yellow[400],
    danger: ColorScale.red[700],
    dangerEmphasis: ColorScale.red[400],
  },
  text: {
    default: ColorScale.mono.white,
    secondary: ColorScale.gray[300],
    muted: ColorScale.gray[300],
    subtle: ColorScale.gray[400],
    accent: ColorScale.blue[300],
    success: ColorScale.green[300],
    warn: ColorScale.yellow[300],
    danger: ColorScale.red[300],
    emphasis: ColorScale.mono.black,
    disabled: ColorScale.mono.disabled,
  },
};
